import { AULoadingManager } from '@assertiva/assertiva-ui';
import Select from './interfaces/select';
import Persist from './interfaces/persist';
import Delete from './interfaces/delete';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export default class HttpClient {
  private axios: AxiosInstance;
  constructor(
    private resource: string,
    private baseUrl?: string,
    private axiosInstace?: AxiosInstance
  ) {
    this.resource = resource;
    this.axios = this.axiosInstace as AxiosInstance;
  }

  async get<T>({
    action = '',
    params = null,
    loading = true,
    config = this.defaultConfig,
    cancelToken,
  }: Select) {
    if (loading) AULoadingManager.show();
    return await this.axios
      .request<T>({
        method: 'GET',
        url: `${this.resource}/${action}${this.createQueryString(params)}`,
        baseURL: this.baseUrl,
        headers: config.headers,
        responseType: config.responseType,
        cancelToken: cancelToken,
      })
      .finally(() => {
        if (loading) AULoadingManager.close();
      });
  }

  async post({
    action = '',
    body,
    history,
    loading = false,
    config = this.defaultConfig,
  }: Persist) {
    if (loading) AULoadingManager.show();
    return await this.axios({
      method: 'POST',
      url: `${this.resource}/${action}`,
      baseURL: this.baseUrl,
      headers: config.headers,
      data: body,
    }).finally(() => {
      if (loading) AULoadingManager.close();
    });
  }

  async put({
    action = '',
    body,
    history,
    loading = false,
    config = this.defaultConfig,
  }: Persist) {
    if (loading) AULoadingManager.show();
    return await this.axios({
      method: 'PUT',
      url: action ? `${this.resource}/${action}` : this.resource,
      baseURL: this.baseUrl,
      headers: config.headers,
      data: body,
    }).finally(() => {
      if (loading) AULoadingManager.close();
    });
  }

  async patch({
    action = '',
    body,
    history,
    loading = true,
    config = this.defaultConfig,
  }: Persist) {
    if (loading) AULoadingManager.show();
    return await this.axios({
      method: 'PATCH',
      url: `${this.resource}/${action}`,
      baseURL: this.baseUrl,
      headers: config.headers,
      data: body,
    }).finally(() => {
      if (loading) AULoadingManager.close();
    });
  }

  async delete({
    action = '',
    loading = false,
    params = null,
    config = this.defaultConfig,
  }: Delete) {
    if (loading) AULoadingManager.show();
    return await this.axios({
      method: 'DELETE',
      url: `${this.resource}/${action}${this.createQueryString(params)}`,
      baseURL: this.baseUrl,
      headers: config.headers,
    }).finally(() => {
      if (loading) AULoadingManager.close();
    });
  }

  createQueryString(params) {
    if (params || (Array.isArray(params) && params.length > 0)) {
      return (
        '?' +
        Object.keys(params)
          .map((key) => {
            const value = params[key];
            if (Array.isArray(value)) {
              const query: string[] = [];

              value.forEach((element, elementIndex) => {
                if (typeof element === 'object') {
                  Object.keys(element).forEach((elementKey) => {
                    query.push(
                      `${key}[${elementIndex}].${encodeURIComponent(
                        elementKey
                      )}=${encodeURIComponent(element[elementKey])}`
                    );
                  });
                } else {
                  query.push(
                    `${encodeURIComponent(key)}=${encodeURIComponent(element)}`
                  );
                }
              });
              return query.join('&');
            } else {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
              );
            }
          })
          .join('&')
      );
    } else {
      return '';
    }
  }

  //TODO:Logar os erros depois
  // onError = (errorResponse) => {
  //   console.log(errorResponse);
  // };

  get defaultConfig(): AxiosRequestConfig {
    return {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }
}
